/* eslint-disable import/prefer-default-export */
import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { useDispatch } from 'react-redux';
import { setShowContextMenu, showVulnModalDelete } from 'store/ManageGeneral/actions';
import { DeleteIcon } from 'Screens/Contextualization/Manage/components/ManageTable/components/ContextMenu/components/styled';
import { ThemeContext } from 'Context';

export const Delete = () => {
  const dispatch = useDispatch();
  const title = useIntl().formatMessage({ id: 'manage.cm.delete' });
  const { themeStyles } = useContext(ThemeContext);

  const handleClick = () => {
    dispatch(showVulnModalDelete());
    dispatch(setShowContextMenu(false));
  };

  return (
    <MenuItem
      title={ title }
      color={ themeStyles.text.contextMenuDelete }
      icon={ <DeleteIcon /> }
      onClick={ handleClick }
    />
  );
};
